import {dynamicWrapper, createRoute} from '@/utils/core';

const routesConfig = app => ({
    path: '/homepage/drawOfPage',
    title: '抽签界面',
    component: dynamicWrapper(app, [import('./model/index')], () => import('./components/index'))
});

export default app => createRoute(app, routesConfig);
